import {invoiceService} from '../../application'
import {
  INVOICE_CHANGE_CLIENT_FILTER_FOR_INVOICE_LOG_CANDIDATES,
  INVOICE_CHANGE_FILTER,
  INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES,
  INVOICE_FETCH_BY_ID,
  INVOICE_FETCH_BY_ID_FAILED,
  INVOICE_FETCH_BY_ID_SUCCESS,
  INVOICE_FETCH_INVOICE_LOG_CANDIDATES,
  INVOICE_FETCH_INVOICE_LOG_CANDIDATES_FAILED,
  INVOICE_FETCH_INVOICE_LOG_CANDIDATES_SUCCESS,
  INVOICE_FILTERED_FETCH,
  INVOICE_FILTERED_FETCH_FAILED,
  INVOICE_FILTERED_FETCH_SUCCESS,
  INVOICE_UPDATE_CASE_INFO_IN_INVOICE_FAILED,
  INVOICE_UPDATE_CASE_INFO_IN_INVOICE_SUCCESS
} from "../mutations/available";
import {getInvoiceLogCandidatesSection} from '../getters/invoices'
import {dataTablePaginationToOffsetAndLimit} from '../../helpers/pagination'
import {RequestState} from "../../requestState";

export async function invoicesChangeFilter({state, commit, dispatch}, filterDelta) {
  const oldFilters = _.cloneDeep(state.invoices.filter);
  commit(INVOICE_CHANGE_FILTER, filterDelta);

  if (_.isEqual(oldFilters, state.invoices.filter)) {
    return
  }

  dispatch('invoicesFetchFiltered')
}

export async function invoicesFetchFiltered({commit, state}) {
  commit(INVOICE_FILTERED_FETCH);

  let request = {
    clientIds: state.invoices.filter.clientIds,
    statuses: state.invoices.filter.statuses,
    pagination: dataTablePaginationToOffsetAndLimit(state.invoices.filter.pagination),
  };

  return invoiceService
    .getFilteredInvoices(request)
    .then(response => {
      commit(INVOICE_FILTERED_FETCH_SUCCESS, response)
    })
    .catch(e => {
      commit(INVOICE_FILTERED_FETCH_FAILED, e);
      throw e
    })
}

export async function invoicesGetInvoice({commit, dispatch, state}, invoiceId) {
  commit(INVOICE_FETCH_BY_ID, {invoiceId});

  return invoiceService.getInvoice({invoiceId})
    .then(response => {
      commit(INVOICE_FETCH_BY_ID_SUCCESS, {invoiceId: invoiceId, response: response});

      if (response.info.status !== 'Draft') {
        commit(INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES, {
          invoiceId, filterDelta: {
            logMode: 'FromInvoice'
          }
        })
      }
    })
    .catch(e => {
      commit(INVOICE_FETCH_BY_ID_FAILED, {invoiceId: invoiceId, error: e});
      throw e
    })
}

export async function invoicesDeleteInvoice({commit, dispatch, state}, {invoiceId}) {
  return invoiceService.deleteInvoice({invoiceId})
    .then(response => {
      dispatch('invoicesFetchFiltered')
    })
}

export async function invoicesGetInvoiceIfRequired({commit, dispatch, state}, invoiceId) {
  if (state.invoices.items[invoiceId]) {
    return state.invoices.items[invoiceId]
  }

  return dispatch('invoicesGetInvoice', invoiceId)
}

export async function invoiceCreate({dispatch}, request) {
  return invoiceService
    .createInvoice(request)
    .then(resp => {
      dispatch('invoicesFetchFiltered');
      return resp
    })
}

export async function invoiceUpdate({dispatch}, {invoiceId, ...other}) {
  return invoiceService
    .updateInvoice({invoiceId, ...other})
    .then(resp => {
      dispatch('invoicesGetInvoice', invoiceId);
      dispatch('invoicesFetchFiltered');
      return resp
    })
}


export async function invoiceAttachCasesWithoutAnomaliesToInvoice({dispatch}, {invoiceId}) {
  return invoiceService.attachCasesWithoutAnomaliesToInvoice({invoiceId})
    .then(response => {
      dispatch('invoicesFetchInvoiceLogCandidates', {invoiceId});
      return response
    })
}

/**
 * for multiple cases
 */
export async function invoiceAttachBatchLogsToInvoice({dispatch}, {invoiceId, logIds}) {
  return invoiceService.attachLogsToInvoice({invoiceId, logIds})
    .then(response => {
      dispatch('invoicesFetchInvoiceLogCandidates', {invoiceId});
      return response
    })
}

export async function invoiceAttachLogsToInvoice({dispatch}, {invoiceId, logIds, affectedCaseId}) {
  return invoiceService.attachLogsToInvoice({invoiceId, logIds})
    .then(response => {
      dispatch('invoiceUpdateCaseInfoInInvoice', {invoiceId, caseId: affectedCaseId});
      dispatch('invoicesGetInvoice', invoiceId);
      return response
    })
}

export async function invoiceDetachLogsToInvoice({dispatch}, {invoiceId, logIds, affectedCaseId}) {
  return invoiceService.detachLogsToInvoice({invoiceId, logIds})
    .then(response => {
      dispatch('invoiceUpdateCaseInfoInInvoice', {invoiceId, caseId: affectedCaseId});
      dispatch('invoicesGetInvoice', invoiceId);
      return response
    })
}

export async function invoicesChangeFilterForInvoiceLogCandidates({state, commit, dispatch}, {invoiceId, filterDelta}) {
  if (!invoiceId) {
    throw new Error(`invoiceId can't be null`)
  }

  const oldFilters = _.cloneDeep(state.invoices.logsByInvoices[invoiceId]);
  commit(INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES, {invoiceId, filterDelta});

  if (_.isEqual(oldFilters, state.invoices.logsByInvoices[invoiceId])) {
    return
  }

  dispatch('invoicesFetchInvoiceLogCandidates', {invoiceId})
}

export async function invoicesChangeClientFilterForInvoiceLogCandidates({state, commit, dispatch}, {invoiceId, filterDelta}) {
  commit(INVOICE_CHANGE_CLIENT_FILTER_FOR_INVOICE_LOG_CANDIDATES, {invoiceId, filterDelta});
}

export async function invoiceUpdateInvoiceLogCandidatesByCase({state, commit, dispatch}, {caseId}) {
  if (state.route.name !== 'InvoicePage') {
    return // no-op
  }

  let invoiceId = parseInt(state.route.params.invoiceId, 10);

  dispatch('invoiceUpdateCaseInfoInInvoice', {invoiceId, caseId});
  dispatch('invoicesGetInvoice', invoiceId);
}

export async function invoicesFetchInvoiceLogCandidates({state, commit, dispatch}, {invoiceId}) {
  commit(INVOICE_FETCH_INVOICE_LOG_CANDIDATES, {invoiceId: invoiceId});

  let section = getInvoiceLogCandidatesSection(state)(invoiceId);

  let filter = section.filter;

  let request = {
    invoiceId: invoiceId,
    dateRange: filter.dateRange,
    title: filter.title,
    metaFilters: filter.metaFilters,
    logMode: filter.logMode,
    caseAnomalyFilter: filter.caseAnomalyFilter,
    pagination: dataTablePaginationToOffsetAndLimit(filter.pagination),
  };

  return invoiceService
    .getInvoicesLogCandidates(request)
    .then(response => {
      commit(INVOICE_FETCH_INVOICE_LOG_CANDIDATES_SUCCESS, {invoiceId, response})
    })
    .catch(error => {
      commit(INVOICE_FETCH_INVOICE_LOG_CANDIDATES_FAILED, {invoiceId, error});
      throw error
    })
}

export async function invoiceChangeInvoiceStatus({state, commit, dispatch}, {invoiceId, newStatus, comment}) {
  let request = {
    invoiceId: invoiceId,
    newStatus: newStatus,
    comment: comment,
  };

  return invoiceService
    .changeInvoiceStatus(request)
    .then(response => {
      dispatch('invoicesGetInvoice', invoiceId);
      return response
    })
}

export async function invoiceCalculateInvoiceAdditionalInfo({state, commit, dispatch}, {invoiceId}) {
  let request = {
    invoiceId: invoiceId,
  };

  return invoiceService
    .calculateInvoiceAdditionalInfo(request)
    .then(response => {
      dispatch('invoicesGetInvoice', invoiceId);
      return response
    })
}

export async function invoiceUpdateCaseInfoInInvoice({state, commit, dispatch}, {invoiceId, caseId}) {
  let section = getInvoiceLogCandidatesSection(state)(invoiceId);

  if (section.requestState !== RequestState.Success) {
    return false
  }

  let filter = section.filter;

  let request = {
    invoiceId: invoiceId,
    dateRange: filter.dateRange,
    title: filter.title,
    metaFilters: filter.metaFilters,
    caseId: caseId,
    logMode: filter.logMode,
    caseAnomalyFilter: filter.caseAnomalyFilter,
    pagination: {
      offset: 0,
      limit: 1
    }
  };

  return invoiceService
    .getInvoicesLogCandidates(request)
    .then(response => {
      commit(INVOICE_UPDATE_CASE_INFO_IN_INVOICE_SUCCESS, {invoiceId, response, caseId})
    })
    .catch(error => {
      commit(INVOICE_UPDATE_CASE_INFO_IN_INVOICE_FAILED, {invoiceId, error, caseId});
      throw error
    })
}

export async function invoiceSendInvoiceToClient({state, commit, dispatch}, {invoiceId}) {

  let request = {
    invoiceId: invoiceId,
  };

  return invoiceService
    .sendInvoiceToClient(request);
}



// WEBPACK FOOTER //
// ./src/store/actions/invoices.js